import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Editor } from '@tiptap/react'
import { useIsInTable } from 'src/hooks/useIsInTable'
import { ChevronDownIcon } from '../../tiptap-icons/chevron-down-icon'
import { AddCircleIcon, ParagraphSpacingIcon, ParagraphSplitIcon, TrashIcon } from '../../tiptap-icons/table'
import { Dropdown } from 'antd'
import type { MenuProps } from 'antd';

export const FloatingTableButton = ({ editor }: { editor: Editor }) => {
  const isInTable = useIsInTable(editor)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const [tableElement, setTableElement] = useState<HTMLElement | null>(null)
  const appendToDom = document.querySelector('.simple-editor-content') || document.body
  useEffect(() => {
  if (!editor || !isInTable) return

  const { node } = editor.view.domAtPos(editor.state.selection.anchor)
  const cell = (node.nodeType === 3 ? node.parentElement : node) as HTMLElement
  const tableCell = cell?.closest('td, th') as HTMLElement | null

  if (tableCell && appendToDom instanceof HTMLElement) {
  const containerRect = appendToDom.getBoundingClientRect()
  const cellRect = tableCell.getBoundingClientRect()

  setPosition({
    top: cellRect.top - containerRect.top + 10,
    left: cellRect.left - containerRect.left + cellRect.width - 24,
  })

  setTableElement(tableCell)
} else {
  setTableElement(null)
}
}, [editor, isInTable, editor.state.selection])


  if (!isInTable || !tableElement) return null

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (!editor || !editor.isEditable) return
    // if (!editor.state.selection.$from.node().type.spec.tableRole) return

    try {
    switch (key) {
      case 'addRowAbove':
        editor.chain().focus().addRowBefore().run()
        break;
      case 'addRowBelow':
        editor.chain().focus().addRowAfter().run()
        break;
      case 'addColumnLeft':
        editor.chain().focus().addColumnBefore().run()
        break;
      case 'addColumnRight':
        editor.chain().focus().addColumnAfter().run()
        break;
      case 'removeRow':
        editor.chain().focus().deleteRow().run()
        break;
      case 'removeColumn':
        editor.chain().focus().deleteColumn().run()
        break;
      case 'removeTable':
        editor.chain().focus().deleteTable().run()
        break;
      case 'mergeCells':
        editor.chain().focus().mergeCells().run()
        break;

      case 'splitCell':
        editor.chain().focus().splitCell().run()
        break;

      case 'toggleHeaderRow':
        editor.chain().focus().toggleHeaderRow().run()
        break;

      case 'toggleHeaderColumn':
        editor.chain().focus().toggleHeaderColumn().run()
        break;

      case 'toggleHeaderCell':
        editor.chain().focus().toggleHeaderCell().run()
        break;
      default:
        break;
    }
    } catch (e) {
      console.warn('Table command failed:', e)
    }
  };

  const items: MenuProps['items'] = [
    {
      key: 'addRowAbove',
      label: "Add row above",
      // action: editor => editor.chain().focus().addRowBefore().run(),
      icon: <AddCircleIcon className='tiptap-button-icon' />
    },
    {
      key: 'addRowBelow',
      label: "Add row below",
      // action: editor => editor.chain().focus().addRowAfter().run(),
      icon: <AddCircleIcon className='tiptap-button-icon' />
    },
    {
      key: 'addColumnLeft',
      label: "Add column left",
      // action: editor => editor.chain().focus().addColumnBefore().run(),
      icon: <AddCircleIcon className='tiptap-button-icon' />
    },
    {
      key: 'addColumnRight',
      label: "Add column right",
      // action: editor => editor.chain().focus().addColumnAfter().run(),
      icon: <AddCircleIcon className='tiptap-button-icon' />
    },
    {
      type: 'divider',
    },
    {
      key: 'removeRow',
      label: "Remove row",
      // action: editor => editor.chain().focus().deleteRow().run(),
      icon: <TrashIcon className='tiptap-button-icon' />
    },
    {
      key: 'removeColumn',
      label: "Remove column",
      // action: editor => editor.chain().focus().deleteColumn().run(),
      icon: <TrashIcon className='tiptap-button-icon' />
    },
    {
      key: 'removeTable',
      label: "Remove table",
      // action: editor => editor.chain().focus().deleteTable().run(),
      icon: <TrashIcon className='tiptap-button-icon' />
    },
    {
      type: 'divider',
    },
    {
      key: 'mergeCells',
      label: "Merge cells",
      // action: editor => editor.chain().focus().mergeCells(),
      icon: <ParagraphSpacingIcon className='tiptap-button-icon' />
    },
    {
      key: 'splitCell',
      label: "Split cell",
      // action: editor => editor.chain().focus().splitCell().run(),
      icon: <ParagraphSplitIcon className='tiptap-button-icon' />
    },
    // {
    //   label: "Toggle header row",
    //   type: 'action',
    //   action: editor => editor.chain().focus().toggleHeaderRow().run()
    // },
    // {
    //   label: "Toggle header column",
    //   type: 'action',
    //   action: editor => editor.chain().focus().toggleHeaderColumn().run()
    // },
    // {
    //   label: "Toggle header cell",
    //   type: 'action',
    //   action: editor => editor.chain().focus().toggleHeaderCell().run()
    // },
  ];

  const button = (
    <div
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 1
      }}
    >
      <Dropdown menu={{ items, onClick }} trigger={['click']} rootClassName='sapp-table-dropdown'
      // getPopupContainer={() => appendToDom as HTMLElement}
      >
        <button
          className="sapp-table-trigger-button"
          data-active-state={'on'}
          type="button"
        >
          <ChevronDownIcon width={'16px'} height={'16px'} />
        </button>
      </Dropdown>
    </div>
  )

  return createPortal(button, appendToDom)
}
